// extracted by mini-css-extract-plugin
export default {"component":"v5H0R94i","s":"rSjAC0E9","regular":"tN6TiIFp","m":"KOUxDIa5","l":"lTSccIel","center":"j84FFcJ9"};